import React from 'react';

const SuccessPage = () => {
  return (
    <div className="success-page">
      <h1>Thank You!</h1>
      <p>Your form has been successfully submitted.</p>
    </div>
  );
};

export default SuccessPage;
